/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import {graphql, StaticQuery} from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"

import {rhythm} from "../utils/typography"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const {author, social} = data.site.siteMetadata;
        return (
          <Container>
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                minWidth: 50,
                borderRadius: `100%`,
              }}
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
            <div>
              <p>
                Written by <strong>{author}</strong> who is building useful things from Washington DC.
              </p>
              <p>Thanks for the supports with <a href={`https://twitter.com/${social.twitter}`}> Twitter</a> or <a
                target="_blank" rel="noopener noreferrer" href="https://www.buymeacoffee.com/w2TItqd">
                Coffee!
              </a>


              </p>

              <a target="_blank" rel="noopener noreferrer" href="https://www.buymeacoffee.com/w2TItqd">
                <p style={{textAlign: 'center', marginTop: '5%'}}>
                  <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"/>
                </p>
              </a>

            </div>
          </Container>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`;

const Container = styled.div`
  display: flex;
`;

export default Bio
